import { ReactNode, useEffect, useState } from 'react';
import { AccountContext } from './account';
import { getMyAccounts } from './api/accounts';
import { useAuth } from '@/hooks/use-auth';
import { AccountDto } from '@/api-client/autogenerated';
import { useQuery } from '@tanstack/react-query';

interface AccountProviderProps {
  children: ReactNode;
}

export function AccountProvider({ children }: AccountProviderProps) {
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const [selectedAccount, setSelectedAccount] = useState<AccountDto | null>(null);
  const { user } = useAuth();

  const { data: accounts = [] } = useQuery({
    queryKey: ['accounts'],
    queryFn: getMyAccounts,
    enabled: !!user,
  });

  useEffect(() => {
    if (accounts.length > 0 && !selectedAccountId) {
      setSelectedAccountId(accounts[0].accountId);
      setSelectedAccount(accounts[0]);
    }
  }, [accounts, selectedAccountId]);

  useEffect(() => {
    const account = accounts.find((a) => a.accountId === selectedAccountId) || null;
    setSelectedAccount(account);
  }, [accounts, selectedAccountId]);

  const value = {
    accounts,
    selectedAccountId,
    selectedAccount,
    setSelectedAccountId,
  };

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
}
